// extracted by mini-css-extract-plugin
export default {"wrapperPixInput":"PixInput_wrapperPixInput__v4RCr","marginB":"PixInput_marginB__06oYC","tooltipWrapper":"PixInput_tooltipWrapper__5zmB+"};